/**
 * Clé d'idempotence HTTP caisse — générée une fois, conservée sur retry.
 */

export function createCaisseIdempotencyKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `caisse-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}
